var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Some more examples for use of account, hapi, decisions apis can be found in this project also hosted on platform:
 * https://main.gitlab.in.here.com/urbanmobility/taas/backoffice-ui/-/blob/master/src/services/hereAccountService.js
 */
import axios from "axios";
import { getTokenSuccess, setScopedTokenPresent, } from "../store/reducers/userSlice";
import { setIsLoaded } from "../store/reducers/appSlice";
export var getOpenIdInstance = function (domain, haWeb) {
    var url = domain.endsWith("platform.here.com")
        ? "platform.here.com"
        : domain;
    var portalAuthHandler = "https://".concat(url, "/authHandler");
    var options = __assign({ environment: haWeb.server, nonce: new Date().getTime(), redirectUri: portalAuthHandler, noSignUp: true, inviteToken: null, realm: null, state: JSON.stringify({
            redirectUri: portalAuthHandler,
            redirect: window.location.href, // redirect back to the same page
        }) }, haWeb.options);
    return window.here.Account.Openid(options);
};
export var getAccessToken = function (domain) {
    if (domain === void 0) { domain = "platform.here.com"; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get("https://".concat(domain, "/api/portal/accessToken"), {
                        withCredentials: true,
                    })];
                case 1:
                    response = _a.sent();
                    if (response.status != 200) {
                        data = response.data;
                        console.debug("getAccessToken failed: ", data);
                        return [2 /*return*/, Promise.reject(data)];
                    }
                    return [2 /*return*/, response.data.accessToken];
            }
        });
    });
};
/**
 *  This method is to do project scoping of userToken
 * @param token string
 */
export var setTokenScopeToProject = function (token) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var allProjectList, indoorProject, scopeTokenResponse;
    var _a, _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0: return [4 /*yield*/, axios.get("".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_ACCOUNT_CONFIG_URL, "/projects/me"), {
                    headers: {
                        Authorization: "Bearer ".concat(token),
                    },
                    params: {
                        limit: 100,
                        isMember: true,
                    },
                })];
            case 1:
                allProjectList = _f.sent();
                indoorProject = ((_b = allProjectList === null || allProjectList === void 0 ? void 0 : allProjectList.data) === null || _b === void 0 ? void 0 : _b.items) && ((_c = allProjectList === null || allProjectList === void 0 ? void 0 : allProjectList.data) === null || _c === void 0 ? void 0 : _c.items.length)
                    ? allProjectList === null || allProjectList === void 0 ? void 0 : allProjectList.data.items.find(function (project) {
                        return project.id.includes("indoor-");
                    })
                    : null;
                if (!indoorProject) return [3 /*break*/, 3];
                return [4 /*yield*/, axios.post("".concat((_d = window === null || window === void 0 ? void 0 : window.app) === null || _d === void 0 ? void 0 : _d.REACT_APP_PLATFORM_PORTAL_URL, "/scopedTokenExchange"), {
                        scope: indoorProject.hrn,
                    }, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 2:
                scopeTokenResponse = _f.sent();
                dispatch(getTokenSuccess((_e = scopeTokenResponse === null || scopeTokenResponse === void 0 ? void 0 : scopeTokenResponse.data) === null || _e === void 0 ? void 0 : _e.accessToken));
                dispatch(setScopedTokenPresent(true));
                return [3 /*break*/, 4];
            case 3:
                dispatch(getTokenSuccess(token));
                dispatch(setIsLoaded(true));
                _f.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var getUserInfo = function (domain, token) {
    if (domain === void 0) { domain = "account.here.com"; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get("https://".concat(domain, "/openid/userinfo"), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
                case 1:
                    response = _a.sent();
                    if (response.status != 200) {
                        data = response.data;
                        console.debug("getUserInfo failed: ", data);
                        return [2 /*return*/, Promise.reject(data)];
                    }
                    return [2 /*return*/, response.data];
            }
        });
    });
};
export var logIn = function (domain, haWeb) {
    if (domain === void 0) { domain = "platform.here.com"; }
    return __awaiter(void 0, void 0, void 0, function () {
        var sdk_1;
        return __generator(this, function (_a) {
            try {
                sdk_1 = getOpenIdInstance(domain, haWeb);
                // This is required to return a promise for suspence to know we are not done.
                // authorize will redirect in the same window to here account login screen
                // which will basically destroy the app = which is what we want (the app will never be rendered)
                return [2 /*return*/, new Promise(function () {
                        sdk_1.oidcAuthorize();
                    }).catch(function (e) { return console.log(e); })];
            }
            catch (err) {
                console.log(err);
            }
            return [2 /*return*/];
        });
    });
};
export var logOut = function (domain, hereAccountApiBase, token) {
    if (domain === void 0) { domain = "platform.here.com"; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post("".concat(hereAccountApiBase, "/logout"), {}, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
                case 1:
                    response = _a.sent();
                    if (!response) return [3 /*break*/, 3];
                    return [4 /*yield*/, axios.get("https://".concat(domain, "/api/portal/clearAccessToken"), {
                            withCredentials: true,
                        })];
                case 2:
                    res = _a.sent();
                    return [2 /*return*/, res.data];
                case 3: return [2 /*return*/, response.data];
            }
        });
    });
};
